/* eslint-disable @typescript-eslint/naming-convention */
export const SET_CURRENT_ORDER = "@ORDERS/SET_CURRENT_ORDER";
export type SET_CURRENT_ORDER = typeof SET_CURRENT_ORDER;

export const SET_CURRENT_ORDER_MODE = "@ORDERS/SET_CURRENT_ORDER_MODE";
export type SET_CURRENT_ORDER_MODE = typeof SET_CURRENT_ORDER_MODE;

export const UPDATE_CUSTOMER_REFERENCE = "@ORDERS/UPDATE_CUSTOMER_REFERENCE";
export type UPDATE_CUSTOMER_REFERENCE = typeof UPDATE_CUSTOMER_REFERENCE;

export const SET_ORDERS_WITH_ERRORS = "@ORDERS/SET_ORDERS_WITH_ERRORS";
export type SET_ORDERS_WITH_ERRORS = typeof SET_ORDERS_WITH_ERRORS;

export const PURGE_ORDERS = "@ORDERS/PURGE_ORDERS";
export type PURGE_ORDERS = typeof PURGE_ORDERS;

export const UPDATE_ORDER_LINE = "@ORDERS/UPDATE_ORDER_LINE";
export type UPDATE_ORDER_LINE = typeof UPDATE_ORDER_LINE;
